/**
 * Portal Manta · Card6Salvar
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { fmtNum, fmtBRL, extKm } from '../../globals.js';
import { saveOrcGerados } from '../../app-globals.js';

const Card6Salvar = memo(function Card6Salvar_Inner({qual, kpis, loteRef, similaridades, orcamento, escopo, casosFiltrados, salvosHist, setSalvosHist}){
  const [nome, setNome] = useState(qual.nome || '');
  const inputStl = {width:'100%', padding:'8px 12px', border:`1px solid ${M.border}`, borderRadius:4, fontFamily:F.body, fontSize:13, color:M.text, outline:'none'};
  const labelStl = {fontSize:9.5, fontWeight:700, color:M.muted, letterSpacing:.5, marginBottom:5, textTransform:'uppercase'};

  // Adapter para reaproveitar exportadores existentes do v25
  const fakeKpisCompletos = {...qual, ...kpis};
  const payload = useMemo(() => gerarPayload({
    nome: nome.trim() || qual.nome || 'Estudo sem nome',
    kpis: fakeKpisCompletos, loteRef, similaridades, orcamento,
    escopo, casosFiltrados,
  }), [nome, qual, kpis, loteRef, similaridades, orcamento, escopo, casosFiltrados]);

  const salvarLocal = () => {
    const item = {id:'oc-'+Date.now(), ...payload};
    const arr = [...salvosHist, item];
    setSalvosHist(arr); saveOrcGerados(arr);
    window.alert('✓ Estudo "'+payload.meta.nome+'" salvo no navegador.');
  };

  const removerHist = (id) => {
    if (!window.confirm('Remover este estudo do histórico?')) return;
    const arr = salvosHist.filter(x=>x.id!==id);
    setSalvosHist(arr); saveOrcGerados(arr);
  };

  const btnStl = (cor) => ({
    padding:'12px 14px', fontSize:11, fontWeight:700, color:'#fff', border:'none', borderRadius:5, cursor:'pointer',
    background:cor, fontFamily:F.body, display:'flex', alignItems:'center', gap:8, justifyContent:'center',
  });

  return (<div>
    {/* Nome */}
    <div style={{marginBottom:14}}>
      <div style={labelStl}>Nome do estudo</div>
      <input type="text" value={nome} onChange={e=>setNome(e.target.value)} placeholder="Ex: BR-101 Sul · estimativa preliminar" style={inputStl}/>
    </div>

    {/* 5 botões */}
    <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(180px, 1fr))', gap:10, marginBottom:18}}>
      <button onClick={salvarLocal} style={btnStl(M.green)}>
        <span style={{fontSize:16}}>💾</span> Salvar no navegador
      </button>
      <button onClick={()=>exportarJSON(payload)} style={btnStl(M.blue)}>
        <span style={{fontSize:16}}>📋</span> Baixar JSON
      </button>
      <button onClick={()=>exportarExcel(payload)} style={btnStl('#16a34a')}>
        <span style={{fontSize:16}}>📊</span> Baixar Excel
      </button>
      <button onClick={()=>exportarPDF(payload)} style={btnStl('#dc2626')}>
        <span style={{fontSize:16}}>📄</span> Baixar PDF
      </button>
      <button onClick={()=>window.alert('SharePoint Manta · upload manual\n\n1. Baixe JSON/Excel/PDF acima\n2. Acesse a pasta SharePoint do estudo\n3. Arraste os arquivos\n\nIntegração via Power Automate webhook · próxima rodada.')} style={btnStl('#7C3AED')}>
        <span style={{fontSize:16}}>☁️</span> SharePoint
      </button>
    </div>

    {/* Histórico */}
    <div style={{paddingTop:14, borderTop:`1px solid ${M.borderSoft}`}}>
      <div style={{fontSize:11, fontWeight:700, color:M.heading, letterSpacing:.5, textTransform:'uppercase', marginBottom:10}}>
        Estudos salvos · {salvosHist.length}
      </div>
      {salvosHist.length === 0 ? (
        <div style={{padding:'14px 12px', textAlign:'center', color:M.muted, fontSize:11.5, fontStyle:'italic'}}>Nenhum estudo salvo ainda.</div>
      ) : (
        <table style={{width:'100%', borderCollapse:'collapse', fontSize:10.5}}>
          <thead><tr style={{borderBottom:`2px solid ${M.border}`, background:M.bgAlt}}>
            <th style={{padding:'7px 10px', textAlign:'left', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase'}}>Nome</th>
            <th style={{padding:'7px 10px', textAlign:'left', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', width:50}}>UF</th>
            <th style={{padding:'7px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', width:80}}>Ext</th>
            <th style={{padding:'7px 10px', textAlign:'left', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', width:60}}>Ref</th>
            <th style={{padding:'7px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', width:120}}>Estimativa</th>
            <th style={{padding:'7px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontWeight:700, letterSpacing:.5, textTransform:'uppercase', width:110}}>Criado em</th>
            <th style={{width:40}}></th>
          </tr></thead>
          <tbody>
            {salvosHist.slice().reverse().map(o => (
              <tr key={o.id} style={{borderBottom:`1px solid ${M.borderSoft}`}}>
                <td style={{padding:'6px 10px', color:M.heading, fontWeight:600}}>{o.meta.nome}</td>
                <td style={{padding:'6px 10px', fontWeight:700, color:M.muted}}>{o.kpis.uf}</td>
                <td style={{padding:'6px 10px', textAlign:'right', fontFamily:F.mono, color:M.text}}>{fmtNum(o.kpis.extKm,1)}</td>
                <td style={{padding:'6px 10px', fontWeight:700, color:M.accent}}>{o.loteRef?.sigla}</td>
                <td style={{padding:'6px 10px', textAlign:'right', fontFamily:F.mono, fontWeight:700, color:M.green}}>{fmtBRL(o.orcamento.med,0)}</td>
                <td style={{padding:'6px 10px', textAlign:'right', fontSize:9.5, color:M.muted, fontFamily:F.mono}}>
                  {new Date(o.meta.criadoEm).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'})}
                </td>
                <td style={{padding:'6px 8px', textAlign:'right'}}>
                  <button onClick={()=>removerHist(o.id)} style={{padding:'2px 7px', fontSize:11, fontWeight:700, border:`1px solid ${M.red}`, background:'#fff', color:M.red, borderRadius:3, cursor:'pointer'}}>×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>);
});

export { Card6Salvar };
export default Card6Salvar;
